import { AutoformatRule } from '@udecode/plate-autoformat'
import { BlockquotePlugin } from '@udecode/plate-block-quote/react'

import { isParagraph, preFormat } from './utils'

// Code blocks are handled by CodeBlockEnterPlugin (triggers on Enter)
export const autoformatBlocks: AutoformatRule[] = [
    {
        mode: 'block',
        type: BlockquotePlugin.key,
        match: '> ',
        query: isParagraph,
        preFormat,
    },
]
